import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import Messages from './Messages';
import s from './ForgotForm.css';
import Form from '../Form';
import LoginElements from '../LoginElements';
import Input from '../Input';

import {
  ILEXCONNECT_URL,
  SPIROTECH_URL,
  TEST_SPIROTECH_URL
} from '../../constants/websites';
import { getNameValidations } from '../../core/validations';

class ForgotFormView extends React.Component {

  getWrappedRoot = hostname => {
    let wrappedClass = null;
    switch (hostname) {
      case ILEXCONNECT_URL:
        wrappedClass = cx(s.root);
        break;
      case SPIROTECH_URL:
      case TEST_SPIROTECH_URL:
        wrappedClass = cx(s.root, s.spirotech);
        break;
      default:
        wrappedClass = cx(s.root);
        break;
    }
    return wrappedClass;
  };

  getWrappedForm = hostname => {
    let wrappedClass = null;
    switch (hostname) {
      case ILEXCONNECT_URL:
        wrappedClass = cx(s.formGroup);
        break;
      case SPIROTECH_URL:
      case TEST_SPIROTECH_URL:
        wrappedClass = cx(s.formGroupSpirotech);
        break;
      default:
        wrappedClass = cx(s.formGroup);
        break;
    }
    return wrappedClass;
  };

  renderSubmitButton = text => {
    return (
      <div className={s.formGroup}>
        <button className={s.button} type="submit">
          <FormattedMessage {...text} />
        </button>
      </div>
    );
  };

  render(){
    const messages = Messages();
    const { intl, authentication, runtime } = this.props;
    const outerErrorMessage = authentication.get('errorMessage');
    const outerInfoMessage = authentication.get('infoMessage');

    const host = runtime.host;
    const hostname = runtime.hostname;

    // const host = SPIROTECH_URL;
    // const hostname = SPIROTECH_URL;

    const nameValidations = getNameValidations(intl, messages);

    const isInfo = outerErrorMessage || outerInfoMessage;
    const wrappedClassInfo = cx(s.Form_info);
    const wrappedClassError = cx(s.Form_info, s.Form_info__error);
    return (
      <div className={s.root}>
        <div className={s.container}>
          <LoginElements elementType={'LOGO'} hostname={hostname} />
          <div className={s.marginTop}>
            {outerErrorMessage ? (
              <section className={wrappedClassError}>
                <div className={s.flex}>
                  <FormattedMessage {...messages[outerErrorMessage]} />
                  <LoginElements elementType={'BUTTONS_CLEAR'} />
                </div>
              </section>
              ) : null}
            {outerInfoMessage ? (
              <section className={wrappedClassInfo}>
                <div className={s.flex}>
                  <FormattedMessage {...messages[outerInfoMessage]} />
                  <LoginElements elementType={'BUTTONS_CLEAR'} />
                </div>
              </section>) : null}
            { !isInfo ? (
               <Form onSubmit={this.props.onSubmit}>
                <div className={s.formGroup}>
                  <label className={s.label} htmlFor="username">
                    <FormattedMessage {...messages.forgot_button_forgot_text} />
                  </label>
                  <Input
                    name="email"
                    title={intl.formatMessage({
                      ...messages.email_placeholder_register_text,
                    })}
                    type="text"
                    large
                    autofocus
                    maxLength="40"
                    {...nameValidations}
                    required
                  />
                </div>
                {this.renderSubmitButton(messages.forgot_submit_button_text)}
              </Form>
            ) : (<Form/>) }
          </div>
          <LoginElements elementType={'BUTTONS_FORGOT'} />
        </div>
      </div>
    );
  }
}

ForgotFormView.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  authentication: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  runtime: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};


export default injectIntl(withStyles(s)(
  ForgotFormView,
));



// WEBPACK FOOTER //
// ./src/components/ForgotForm/ForgotFormView.js